<template>
  <layout-main-inner title="新增补单">
    <div slot="action">
      <el-button
        type="primary"
        :loading="loading"
        @click="save">保存</el-button>
    </div>
    <el-form
      ref="ruleForm"
      class="order-create-wrap"
      :model="outstock"
      :rules="rules"
      label-position="top">
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">基本信息</template>
        <el-row
          :gutter="20"
          type="flex">
          <el-col :span="8">
            <el-form-item
              label="订单号:"
              prop="code">
              <el-input v-model="outstock.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="下单时间:"
              prop="tradeTime">
              <el-date-picker
                v-model="outstock.tradeTime"
                style="width:100%"
                type="datetime"
                :editable="false"
                :clearable="false"
                placeholder="选择下单时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              required=""
              label="订单标记:"
              prop="orderFlag">
              <el-radio-group v-model="outstock.orderFlag">
                <el-radio-button :label="1">正常</el-radio-button>
                <el-radio-button :label="2">拍A发B</el-radio-button>
                <el-radio-button :label="3">刷单</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="发货仓库:"
              prop="warehouseNo">
              <el-input
                v-model="outstock.warehouseName"
                readonly="">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="selectWarehouse"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="物流模板:"
              prop="logisticsCode">
              <ent-logistics-select
                v-model="outstock.logisticsCode"
                :callback="logisticsSelectCallback"
                :option="{vendorId: $route.query.vendorId}" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="备注:"
              prop="remark">
              <el-input
                v-model="outstock.remark"
                type="textarea"
                :rows="2"
                autosize></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="客户:"
              prop="customerCode">
              {{ outstock.customerName }}
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="发件人信息:">
              <div slot="label">
                <span>发件人信息:</span>
                <el-tooltip
                  effect="dark"
                  content="根据物流模板信息获取">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              {{ outstock.senderName }}-{{ outstock.senderMobile }}-{{ outstock.senderProvince }}{{ outstock.senderCity }}{{ outstock.senderDistrict }}{{ outstock.senderAddress }}
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap
        v-loading="loading"
        style="margin-top:8px"
        hasHeaderSlot>
        <template slot="title">收件人信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="收件人姓名:"
              prop="receiverName">
              <el-input v-model="outstock.receiverName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件人手机:"
              prop="receiverMobile">
              <el-input v-model="outstock.receiverMobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件人电话:"
              prop="receiverTel">
              <el-input v-model="outstock.receiverTel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件省份:"
              prop="receiverProvince">
              <el-input v-model="outstock.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件城市:"
              prop="receiverCity">
              <el-input v-model="outstock.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件区县:"
              prop="receiverDistrict">
              <el-input v-model="outstock.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收件地址:"
              prop="receiverAddress">
              <el-input v-model="outstock.receiverAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap
        v-loading="loading"
        style="margin-top:8px"
        hasHeaderSlot>
        <template slot="title">
          <span>订单明细</span>
          <el-button
            type="primary"
            style="margin-left:10px"
            :loading="loading"
            @click="addProduct">选择商品</el-button>
        </template>
        <el-form-item
          label-width="0"
          prop="salesOrderDetailList">
          <el-table
            v-loading="loading"
            show-summary
            :summary-method="getSummaries"
            :data="outstock.salesOrderDetailList"
            border>
            <el-table-column
              :resizable="false"
              label="商品名称"
              prop="productName"></el-table-column>
            <el-table-column
              label="商品编码"
              width="100"
              :resizable="false"
              prop="productNumber"></el-table-column>
            <el-table-column
              label="下单数量"
              :resizable="false"
              prop="num">
              <template slot-scope="{row, $index}">
                <el-form-item
                  label-width="0"
                  :prop="'salesOrderDetailList.' + $index + '.num'"
                  :rules="[{required: true, message: '请输入下单数量', trigger: 'blur'}]">
                  <el-input-number
                    v-model="outstock.salesOrderDetailList[$index].num"
                    :precision="0"
                    :min="1"></el-input-number>{{ row.measureUnit | measureUnitName() }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="零售价(¥)"
              :resizable="false"
              prop="retailPrice">
              <template slot-scope="{$index}">
                <el-form-item
                  label-width="0"
                  :prop="'salesOrderDetailList.' + $index + '.retailPrice'"
                  :rules="[{required: true, message: '请输入零售价', trigger: 'blur'}]">
                  <el-input-number
                    v-model="outstock.salesOrderDetailList[$index].retailPrice"
                    style="width: 100%"
                    :precision="2"
                    :min="0"></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="单件成交价(¥)"
              :resizable="false"
              prop="actualPrice">
              <template slot-scope="{$index}">
                <el-form-item
                  label-width="0"
                  :prop="'salesOrderDetailList.' + $index + '.actualPrice'"
                  :rules="[{required: true, message: '请输入单件成交价', trigger: 'blur'}]">
                  <el-input-number
                    v-model="outstock.salesOrderDetailList[$index].actualPrice"
                    style="width: 100%"
                    :precision="2"
                    :max="outstock.salesOrderDetailList[$index].retailPrice"
                    :min="0"></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
    </template>
    <product-select-modal
      ref="modal"
      :option="{vendorId: $route.query.vendorId}"
      @update:list="updateProductItems" />
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
    <product-muti-select-modal
      ref="muti"
      :callback="updateProductItems" />
  </layout-main-inner>
</template>
<script>
import ProductSelectModal from '../orders/busi/product-select-modal.vue'
import NP from 'number-precision'
import EntLogisticsSelect from '../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
import WarehouseSelectModal from '../orders/busi/warehouse-select-modal.vue'
// import VendorTagSelect from '../../components/business/vendor-tag-select.vue'
import moment from 'moment'
// import CustomerSelectModal from '../orders/busi/customer-select-modal.vue'
import ProductMutiSelectModal from '../../components/product-muti-select-modal.vue'
export default {
  name: 'AfterSalesCreate',
  components: { ProductSelectModal, EntLogisticsSelect, WarehouseSelectModal, ProductMutiSelectModal },
  props: {},
  data() {
    return {
      loading: false,
      outstock: {
        customerCode: null,
        customerName: '',
        // outerOrderCode: '1212121212', // string 外部订单编码,例如 天猫订单编号/京东订单编号
        payStatus: 2, // int //支付状态(目前只支持全部支付的订单)\r     0:未支付\r     1:部分支付\r     2:全部支付
        outStatus: 0, // int //发货状态\r 0:未发货(接受订单未创建出库单前的状态)\r 1:发货中(生成出库单,出库单未出库确认前的状态)\r 2:发货完成(出库单全部出库确认，且出库量=下单量，ps:目前订单完结必须下单量=出库量，不支持出部分完结的情况)\r 9:挂起（库存不足等无法出库的状态）
        hangReason: '', // string //挂起原因,当发货状态为"挂起"时有值
        warehouseNo: null, // string //仓库编码,不为空则指定仓库出库
        warehouseName: '',
        tradeTime: null, // long //下单时间
        source: 5, // int //订单来源//1，天猫；2，京东；3，联营合伙人小程序；4，大健康事业小程序；5，其他小平台订单；9，线下订单；
        remark: '', // string //备注
        code: 'XSD' + moment().format('YYYYMMDDHHmmss'), // string //销售单号
        orderFlag: 1, // string //订单标记:客服审核做的一些特殊标记，也可以作为标旗使用
        outType: 1,
        totalAmount: 0, // long //订单金额 单位为分,订单总金额=应收金额+已收金额=\r     商品总金额-订单折扣金额+快递费用
        itemAmount: 0, // long //商品总金额
        serviceFee: 0, // long //COD 服务费
        freight: 0, // long //快递费用
        logisticsCode: null, // string //物流公司编码,可能客户指定地址快递发货的
        discountAmount: 0, // long //订单折扣金额
        buyerNick: '', // string //买家昵称
        receiverName: '', // string //收货人
        receiverTel: '', // string //收货人移动电话
        receiverMobile: '', // string //收货人固定电话
        receiverProvince: '', // string //省份
        receiverCity: '', // string //城市
        receiverDistrict: '', // string //区县
        receiverAddress: '', // string //地址详情
        senderName: '', // string //发件人名称
        senderProvince: '', // string //发件人-省份
        senderCity: '', // string //发件人-城市
        senderDistrict: '', // string //发件人-区县
        senderAddress: '', // string //发件人-地址详情
        senderTel: '', // string //发件人-移动电话
        senderMobile: '', // string //发件人-固定电话
        invoiceFlag: 0, // int //是否需要发票 1:需要 0:不需要
        invoiceHeader: '', // string //发票抬头
        invoiceTaxNumber: '', // string //发票税号
        salesOrderDetailList: []
        // {
        //   salesOrderId: '', // long //销售单id
        //   saleOrderDetailId: '', // long //销售单明细id(拍A发B调整，传原明细Id)
        //   skuId: '', // long //商品id
        //   skuCode: '', // string //商品编码
        //   skuSpec: '', // string //商品规格
        //   num: 0, // int //下单数量
        //   remark: '', // string //备注
        //   outerOrderDetailId: '', // int //外部订单明细ID
        //   sourceSalesDetailId: '', // long //商品进行调整后记录对应调整前的明细
        //   sourceOrderCode: '', // string //交易平台订单
        //   subSourceOrderCode: '', // string //交易平台子订单编码
        //   status: 0, // int //状态：0:正常 1:作废(已调整)
        //   retailPrice: 0, // long //零售价=实际成交价+单件商品折扣金额
        //   actualPrice: 0, //long //实际成交价
        //   discountAmount: 0 // long //单件商品折扣金额
        // }
      }
      // rules:
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse
    }),
    rules() {
      const { receiverMobile, receiverTel } = this.outstock
      return {
        // customerCode: [{ required: true, message: '请选择客户', trigger: 'change' }],
        code: [{ required: true, message: '请输入订单号', trigger: 'change' }],
        tradeTime: [{ required: true, message: '请选择下单时间', trigger: 'change' }],
        outType: [{ required: true, message: '请选择订单标记', trigger: 'change' }],
        warehouseNo: [{ required: true, message: '请选择发货仓库', trigger: 'change' }],
        logisticsCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        senderName: [{ required: true, message: '请输入发件人姓名', trigger: 'change' }],
        senderMobile: [{ required: true, message: '请输入发件人手机', trigger: 'change' }],
        senderProvince: [{ required: true, message: '请输入发件省份', trigger: 'change' }],
        senderCity: [{ required: true, message: '请输入发件城市', trigger: 'change' }],
        senderDistrict: [{ required: true, message: '请输入发件区县', trigger: 'change' }],
        senderAddress: [{ required: true, message: '请输入发件地址', trigger: 'change' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'change' }],
        receiverMobile: [{ required: (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'change' }],
        receiverTel: [{ required: (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'change' }],
        receiverProvince: [{ required: true, message: '请输入收件省份', trigger: 'change' }],
        receiverCity: [{ required: true, message: '请输入收件城市', trigger: 'change' }],
        receiverDistrict: [{ required: true, message: '请输入收件区县', trigger: 'change' }],
        receiverAddress: [{ required: true, message: '请输入收件地址', trigger: 'change' }],
        salesOrderDetailList: [{ type: 'array', required: true, message: '请选择订单明细', trigger: 'change' }]
      }
    }
  },
  watch: {
    'outstock.salesOrderDetailList': {
      handler(val) {
        let itemAmount = 0
        let discountAmount = 0
        val.forEach(i => {
          itemAmount = NP.plus(itemAmount, NP.times(i.retailPrice, i.num))
          discountAmount = NP.plus(discountAmount, NP.times(NP.minus(i.retailPrice, i.actualPrice), i.num))
        })
        this.outstock.itemAmount = itemAmount
        this.outstock.discountAmount = discountAmount
        this.outstock.totalAmount = NP.minus(itemAmount, discountAmount)
      },
      deep: true
    }
  },
  mounted() {
    this.salesdetail()
  },
  methods: {
    logisticsSelectCallback(row) {
      this.outstock.senderName = row.senderName
      this.outstock.senderProvince = row.senderProvinceName
      this.outstock.senderCity = row.senderCityName
      this.outstock.senderDistrict = row.senderAreaName
      this.outstock.senderAddress = row.senderAddress
      this.outstock.senderMobile = row.senderPhone
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        departmentId: this.$route.query.departmentId,
        productType: 1,
        useType: 1
      })
    },
    warehouseCallback(row) {
      this.outstock.warehouseNo = row.warehouseNo
      this.outstock.warehouseName = row.warehouseName
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计：¥' + this.outstock.totalAmount
          return
        }
        if (index === 1) {
          return
        }
        const values = data.map(item => {
          if (index >= 3) {
            return NP.times(Number(item[column.property]), Number(item.num))
          } else {
            return Number(item[column.property])
          }
        })
        // console.log(values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return NP.plus(prev, curr)
            } else {
              return prev
            }
          }, 0)
          if (index === 2) {
            sums[index] += '件'
          } else {
            sums[index] = '¥' + sums[index]
          }
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    addProduct() {
      const ids = this.outstock.salesOrderDetailList.map(i => i.skuId)
      this.$refs.muti.fetch(ids)
    },
    updateProductItems(list) {
      const detailList = this.outstock.salesOrderDetailList
      const result = list.map(i => {
        const item = detailList.find(s => s.productId === i.productId)
        if (item) {
          return {
            ...i,
            ...item
          }
        } else {
          return {
            ...i,
            salesOrderId: '',
            saleOrderDetailId: '',
            skuId: i.productId,
            skuCode: i.productNumber,
            skuSpec: '',
            num: 1,
            remark: '',
            outerOrderDetailId: '',
            sourceSalesDetailId: '',
            sourceOrderCode: '',
            subSourceOrderCode: '',
            status: 0,
            retailPrice: 0,
            actualPrice: 0,
            discountAmount: 0
          }
        }
      })
      this.outstock.salesOrderDetailList = result
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('outstock/salesadd', {
            payload: {
              ...this.outstock,
              tradeTime: +this.outstock.tradeTime,
              bizType: 4,
              // ownerCode: this.$route.query.departmentId,
              totalAmount: NP.times(this.outstock.totalAmount, 100),
              itemAmount: NP.times(this.outstock.itemAmount, 100),
              discountAmount: NP.times(this.outstock.discountAmount, 100),
              salesOrderDetailList: this.outstock.salesOrderDetailList.map(i => ({
                salesOrderId: '',
                saleOrderDetailId: '',
                skuId: i.productId,
                skuCode: i.productNumber,
                skuSpec: '',
                num: i.num,
                remark: '',
                outerOrderDetailId: '',
                sourceSalesDetailId: '',
                sourceOrderCode: '',
                subSourceOrderCode: '',
                status: 0,
                retailPrice: NP.times(i.retailPrice, 100),
                actualPrice: NP.times(i.actualPrice, 100),
                discountAmount: NP.minus(NP.times(i.retailPrice, 100), NP.times(i.actualPrice, 100))
              }))
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    salesdetail() {
      this.loading = true
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.$route.query.salesOrderId
        },
        success: res => {
          this.loading = false

          const order = res.data.data
          console.log(order)
          this.outstock = {
            ...this.outstock,
            ownerCode: order.ownerCode,
            customerCode: order.customerCode,
            customerName: order.customerName,
            payStatus: order.payStatus,
            outStatus: 0, // int //发货状态\r 0:未发货(接受订单未创建出库单前的状态)\r 1:发货中(生成出库单,出库单未出库确认前的状态)\r 2:发货完成(出库单全部出库确认，且出库量=下单量，ps:目前订单完结必须下单量=出库量，不支持出部分完结的情况)\r 9:挂起（库存不足等无法出库的状态）
            hangReason: '', // string //挂起原因,当发货状态为"挂起"时有值
            warehouseNo: order.warehouseNo, // string //仓库编码,不为空则指定仓库出库
            warehouseName: (this.warehouse.find(i => i.warehouseNo === order.warehouseNo) || {}).warehouseName,
            tradeTime: +Date.now(), // long //下单时间
            source: 5, // int //订单来源//1，天猫；2，京东；3，联营合伙人小程序；4，大健康事业小程序；5，其他小平台订单；9，线下订单；
            remark: `售后补单-${order.code}`, // string //备注
            code: 'XSD' + moment().format('YYYYMMDDHHmmss'), // string //销售单号
            orderFlag: +order.orderFlag ? +order.orderFlag : 1, // string //订单标记:客服审核做的一些特殊标记，也可以作为标旗使用
            outType: order.outType,
            totalAmount: 0, // long //订单金额 单位为分,订单总金额=应收金额+已收金额=\r     商品总金额-订单折扣金额+快递费用
            itemAmount: 0, // long //商品总金额
            serviceFee: 0, // long //COD 服务费
            freight: 0, // long //快递费用
            logisticsCode: order.logisticsCode ? +order.logisticsCode : null, // string //物流公司编码,可能客户指定地址快递发货的
            discountAmount: 0, // long //订单折扣金额
            buyerNick: '', // string //买家昵称
            receiverName: order.receiverName, // string //收货人
            receiverTel: order.receiverTel, // string //收货人移动电话
            receiverMobile: order.receiverMobile, // string //收货人固定电话
            receiverProvince: order.receiverProvince, // string //省份
            receiverCity: order.receiverCity, // string //城市
            receiverDistrict: order.receiverDistrict, // string //区县
            receiverAddress: order.receiverAddress, // string //地址详情
            senderName: order.senderName, // string //发件人名称
            senderProvince: order.senderProvince, // string //发件人-省份
            senderCity: order.senderCity, // string //发件人-城市
            senderDistrict: order.senderDistrict, // string //发件人-区县
            senderAddress: order.senderAddress, // string //发件人-地址详情
            senderTel: order.senderTel, // string //发件人-移动电话
            senderMobile: order.senderMobile, // string //发件人-固定电话
            invoiceFlag: 0, // int //是否需要发票 1:需要 0:不需要
            invoiceHeader: '', // string //发票抬头
            invoiceTaxNumber: '' // string //发票税号
            // salesOrderDetailList: order.detailList.map(i => {
            //   return {
            //     ...i,
            //     productId: i.skuId,
            //     productName: i.skuName,
            //     productNumber: i.skuCode,
            //     num: 0,
            //     retailPrice: NP.divide(Number(i.retailPrice), 100),
            //     discountAmount: NP.divide(Number(i.discountAmount), 100),
            //     actualPrice: NP.divide(Number(i.actualPrice), 100)
            //   }
            // })
          }
          // this.vendorInfo.details = res.data.data.detailList.map(i => {
          //   return {
          //     productId: i.skuId,
          //     productNumber: i.skuCode,
          //     goodsCount: 0,
          //     returnedGoodsCount: 0,
          //     productName: i.skuName,
          //     num: i.num
          //   }
          // })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.order-create-wrap .el-table__footer-wrapper tbody {
  td:nth-child(1) {
    font-size: 14px;
    color: red;
  }
}
</style>
